/* unplugin-vue-components disabled */import script from "./Enroll.vue?vue&type=script&setup=true&lang=js"
export * from "./Enroll.vue?vue&type=script&setup=true&lang=js"

import "./Enroll.vue?vue&type=style&index=0&id=28f164a6&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28f164a6"]])

export default __exports__